import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const Providers = registerClientReference(
    function() { throw new Error("Attempted to call Providers() from the server but Providers is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/providers.tsx",
    "Providers",
);
